var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.865 12.167a1 1 0 0 1-.866 1.5H3a1 1 0 0 1-.866-1.5L7.134 3.5a1 1 0 0 1 1.732 0l4.999 8.667ZM8 10.375a.958.958 0 1 0 0 1.917.958.958 0 0 0 0-1.917ZM7.09 6.93l.155 2.834a.25.25 0 0 0 .25.236h1.01a.25.25 0 0 0 .25-.236L8.91 6.93a.25.25 0 0 0-.25-.263H7.34a.25.25 0 0 0-.25.263Z",
    fill: "currentColor"
  })));
};

export default SvgExclamationTriangle;